
import { motion } from 'framer-motion';
import HeroSection from '../../ComingSoonSections/HeroSection';
import OurFeaturesSection from '../../ComingSoonSections/OurFeatures';
import AppsSection from '../../ComingSoonSections/AppsSection';
import RevolutionaryHealthcare from '../../ComingSoonSections/RevolutionHealthSection';
import PlansSection from '../../ComingSoonSections/PlansSection';
import ContactSection from '../../ComingSoonSections/ContactSection';
import FooterSection from '../../ComingSoonSections/Footer';
import HeaderSection from './Header';

export default function NewComingSoon() {
    
    // Animation variants for sections
    const sectionVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: 'easeOut' },
        },
    };

    return (
        <div className="font-roboto">
            <motion.div id='about'  variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
                <HeroSection />
            </motion.div>
            <motion.div id='features'  variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
                <OurFeaturesSection />
            </motion.div>
        
            <motion.div id='ourApp'  variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
                <AppsSection     />
            </motion.div>
        
            <motion.div id='revolutionary' variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
                <RevolutionaryHealthcare     />
            </motion.div>
            <motion.div id='plans'  variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
                <PlansSection     />
            </motion.div>
            <motion.div id='contact'  variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
                <ContactSection     />
            </motion.div>
        
        
        </div>
    );
}
